import type { FunctionComponent } from "react";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { useResponsive } from "shared/hooks";
import { theme } from "shared/lib/styles";

import { useMyDailyFive } from "scmp-app/components/my-news/my-daily-five/hooks";
import { PrimaryArticle } from "scmp-app/components/my-news/my-daily-five/my-daily-five-article/primary-article";
import { MynewsCompleteTypeImp } from "scmp-app/components/my-news/mynews-complete-type-imp";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import {
  Container,
  FirstArticleWrapper,
  RestArticlesWrapper,
  StyledSecondaryArticle,
  StyledTertiaryArticle,
} from "./styles";

export const MyDailyFiveArticles: FunctionComponent = () => {
  const { contents } = useMyDailyFive();
  const [firstContent, ...restContents] = contents;
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);

  if (!firstContent || !restContents || restContents.length < 4) return null;
  const displayOrderList = isMobile ? [0, 1, 2, 3] : [0, 2, 1, 3];

  const handleArticleClick = (number: number, entityId?: string) => {
    sendGA4Tracking({
      action: "click",
      category: "mynews",
      customized_parameters: {
        action_type: "read",
        article_id: entityId ?? "",
        position: number,
        trigger_point: "index",
      },
      subcategory: "mydaily",
    });
  };

  return (
    <>
      <BaseLinkContextProvider
        customQueryParameters={{
          module: "Your_Daily_5",
          pgtype: "my_news",
        }}
      >
        <Container>
          <FirstArticleWrapper>
            <PrimaryArticle
              content={firstContent.node}
              onClick={entityId => {
                handleArticleClick(1, entityId);
              }}
            />
          </FirstArticleWrapper>
          <RestArticlesWrapper>
            {restContents.map((_content, index) => {
              const currentOrder = displayOrderList[index];
              const number = currentOrder + 2;
              return [2, 5].includes(number) ? (
                <StyledSecondaryArticle
                  content={restContents[currentOrder].node}
                  key={restContents[currentOrder].node.entityId}
                  number={number}
                  onClick={entityId => {
                    handleArticleClick(number, entityId);
                  }}
                />
              ) : (
                <StyledTertiaryArticle
                  content={restContents[currentOrder].node}
                  key={restContents[currentOrder].node.entityId}
                  number={number}
                  onClick={entityId => {
                    handleArticleClick(number, entityId);
                  }}
                />
              );
            })}
          </RestArticlesWrapper>
        </Container>
      </BaseLinkContextProvider>
      <MynewsCompleteTypeImp complete_type="daily5" />
    </>
  );
};
MyDailyFiveArticles.displayName = "MyDailyFiveArticles";
